// Socket event type definitions
export const SOCKET_EVENTS = {
    AUTH_REFRESH: 'auth-refresh',
    CONNECTED: 'connected',
    NOTIFICATION_NEW: 'notification-new',
    PING: 'ping',
    PONG: 'pong',
};
